module.exports = __webpack_public_path__ + "static/img/app_icon.e0d2a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app_icon.png
// module id = SmC9
// module chunks = 10